import color from "../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
    mt: 3,
    ml: 3,
    mr: 2
  },
  gridText: {
    fontSize: "22px",
    fontWeight: "600"
  },
  mainContainer: {
    // justifyContent: "end",
  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 3,
    borderRadius: "20px",
    height: "fit-content",
  },
  backButton: {
    borderRadius: 50,
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "500",
    mr: 2,
  },
  addButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 3,
  },
  tableHead: {
    fontWeight: "600",
    fontSize: "14px",
    color: '#878787',
  },
  tabledata: {
    fontSize: "14px",
    color: color.text,
  },
  tableActiondata: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  edit: {
    backgroundColor: "#A3E1FB",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
    cursor: "pointer",
  },
  delete: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
    cursor: "pointer",
  },
  noShadow: {
    mt: 2
  },
  modalInput: {
    display: "flex",
    py: "19px",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    width: "100%"
  },
  inputLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.text,
    mb: 1,
  },
  inputBox: {
    mb: 2,
  },
  dateInput: {
    width: "100%",
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  statusActive: {
    color: "#28AA4A",
    fontWeight: "500",
  },
  statusInactive: {
    color: "#ff0000",
    fontWeight: "500",
  },
  emptyState: {
    textAlign: "center",
    py: 4,
    color: color.lightText,
  }
};

export default style;

